export default "__VITE_ASSET__iBZE7O7l__"